import React from 'react';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import FormGroup from '../../components/bootstrap/forms/FormGroup';
import Button from '../../components/bootstrap/Button';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Label from '../../components/bootstrap/forms/Label';

const ForgotPassword = () => {
    return (
        <React.Fragment>
            <PageWrapper title='Forgot Password'>
                <div className='row align-items-center justify-content-center'>
                    <div className='col-xl-6 col-sm-12 left-aside'></div>
                    <div className='col-xl-6 col-sm-12 right-aside'>
                        <div className='col-xl-6'>
                            <img
                                src={require('../../assets/img/logo.png')}
                                width='50'
                                alt='Liiftsocial'
                            />
                            <h3 className='greeting-text'>Forgot Password</h3>
                            <p className='greeting-subtext'>
                                Enter your email and you will receive an email
                                with the instructions to reset your password.
                            </p>
                            <form className='row g-4 login-form'>
                                <div className='col-12'>
                                    <Label htmlFor='login-email'>Email</Label>
                                    <FormGroup
                                        id='login-email'
                                        isFloating
                                        label='Your email'>
                                        <input
                                            type='email'
                                            className='form-control'
                                        />
                                    </FormGroup>
                                </div>
                                <div className='col-12 mt-5'>
                                    <Button
                                        color='primary'
                                        className='w-100 py-3'>
                                        Submit
                                    </Button>
                                </div>
                            </form>
                            <div className='col-12 mt-4'>
                                <div
                                    className='d-flex'
                                    style={{ justifyContent: 'center' }}>
                                    <a
                                        href='/login'
                                        className='forgot-pass-text'
                                        style={{ marginLeft: '5px' }}>
                                        Back to login
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PageWrapper>
        </React.Fragment>
    );
};

export default ForgotPassword;
